import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ActualitesService from "../../services/actualitesService";

const initialState = {
  Actualites: [],
  ActualiteId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements:0,
  isError: null,
  isStatut: "idle",
  message: "",
};

export const createActualite = createAsyncThunk(
  "Actualites/create",
  async (data, thunkAPI) => {
    try {
      const response = await ActualitesService.createActualite(data);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllActualite = createAsyncThunk(
  "Actualite/getAll",
  async (params, thunkAPI) => {
    try {
      const response = await ActualitesService.getAllActualite(params);
      if (!response.success) {
        
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateActualite = createAsyncThunk(
  "Actualite/update",
  async ({id,data}, thunkAPI) => {
    try {
      // const token = thunkAPI.getState().auth.user.token;
      const response = await ActualitesService.updateActualite(id, data);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get user Villess
export const getActualiteById = createAsyncThunk(
  "Actualite/id",
  async (id, thunkAPI) => {
    try {
      const response = await ActualitesService.getActualiteById(id);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;

    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteActualite = createAsyncThunk(
  "Actualite/delete",
  async (id, thunkAPI) => {
    try {
      const response = await ActualitesService.DeleteActualite(id);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteActualiteImage = createAsyncThunk(
  "ActualiteImage/delete",
  async (id, thunkAPI) => {
    try {
      const response = await ActualitesService.deleteImage(id);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createActualiteImage = createAsyncThunk(
  "ActualiteImages/create",
  async (data, thunkAPI) => {
    try {
      const response = await ActualitesService.createImage(data);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const ActualiteSlice = createSlice({
  name: "actualites",
  initialState,
  reducers: {
    clearNews: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createActualite.pending, (state) => {
        state.isStatut = "loading";
      })
      .addCase(createActualite.fulfilled, (state, action) => {
        state.isStatut = "success";
        state.Actualites.unshift(action.payload?.data);
      })
      .addCase(createActualite.rejected, (state, action) => {
        state.isStatut = "error";
      })
      .addCase(getAllActualite.pending, (state) => {
        state.isStatut = "loading";
      })
      .addCase(getAllActualite.fulfilled, (state, action) => {
        state.isStatut = "success";
        state.Actualites = action.payload.data;
        state.currentPage=action.payload.pagination.current_page
        state.pageSize=action.payload.pagination.limit
        state.totalElements=action.payload.pagination.total_items
      })
      .addCase(getAllActualite.rejected, (state, action) => {
        state.isStatut = "error";
        // state.message = action.payload.message;
      })
      .addCase(updateActualite.pending, (state) => {
        state.isStatut = "loading";
      })
      .addCase(updateActualite.fulfilled, (state, action) => {
        state.isStatut = "success";
        // state.Actualites = action.payload;
      })
      .addCase(updateActualite.rejected, (state, action) => {
        state.isLoading = false;
        // state.message = action.payload.message;
      })
      .addCase(getActualiteById.pending, (state) => {
        state.isStatut = 'loading';
      })
      .addCase(getActualiteById.fulfilled, (state, action) => {
        state.isStatut = "success";
        state.ActualiteId = action.payload.data;
      })
      .addCase(getActualiteById.rejected, (state, action) => {
        state.isStatut = 'error';
        // state.message = action.payload.message;
      })
      .addCase(deleteActualite.pending, (state) => {
        state.isStatut = "loading";
      })
      .addCase(deleteActualite.fulfilled, (state, action) => {
        state.isStatut = "success";
        state.Actualites = state.Actualites.filter(
          (goal) => goal.id !== action.payload.id
        );
      })
      .addCase(deleteActualite.rejected, (state, action) => {
        state.isStatut = "error";
        // state.isError = action.payload.message;
        state.message = action.payload.message;
      })
      .addCase(createActualiteImage.pending, (state) => {
        state.isStatut = "loading";
      })
      .addCase(createActualiteImage.fulfilled, (state, action) => {
        state.isStatut = "success";
        // state.Actualites.unshift(action.payload?.data);
      })
      .addCase(createActualiteImage.rejected, (state, action) => {
        state.isStatut = "error";
      })
      .addCase(deleteActualiteImage.pending, (state) => {
        state.isStatut = "loading";
      })
      .addCase(deleteActualiteImage.fulfilled, (state, action) => {
        state.isStatut = "success";
        // state.Actualites = state.Actualites.filter(
        //   (goal) => goal.id !== action.payload.id
        // );
      })
      .addCase(deleteActualiteImage.rejected, (state, action) => {
        state.isStatut = "error";
        state.message = action.payload.message;
      });
  },
});

export const { clearNews } = ActualiteSlice.actions;
export default ActualiteSlice.reducer;
